import GenericNewsImage from "../../../assets/news.png";
import TheRecordImage from "../../../assets/the-record.png";
import DarkReadingImage from "../../../assets/darkreading.png";
import KrebsImage from "../../../assets/krebs.png";
import Law360Image from "../../../assets/law360.png";
import JdSupraImage from "../../../assets/jdsupra.png";
import CyberscoopImage from "../../../assets/cyberscoop.png";
import DataBreachesImage from "../../../assets/databreachesnet.png";
import {isEmpty, isString} from "underscore";

export const whichImage = (news, theme) => {
  if (!isString(news.feed) || isEmpty(news.feed)) {
    return GenericNewsImage;
  }
  const feedName = news.feed;
  if (feedName.match(/BreachRx/i)) {
    return theme.palette.logo;
  }
  if (feedName.match(/The\s?Record/i)) {
    return TheRecordImage;
  }
  if (feedName.match(/Dark\s?Reading/i)) {
    return DarkReadingImage;
  }
  if (feedName.match(/Krebs\s?on\s?Security/i)) {
    return KrebsImage;
  }
  if (feedName.match(/Law360/i)) {
    return Law360Image;
  }
  if (feedName.match(/JD\s?Supra/i)) {
    return JdSupraImage;
  }
  if (feedName.match(/Cyberscoop|Fedscoop/i)) {
    return CyberscoopImage;
  }
  if (feedName.match(/DataBreaches\.net/i)) {
    return DataBreachesImage;
  }
  return GenericNewsImage;
};
